"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorNameMatches = exports.getNameFromClassInstance = void 0;
/**
 * TODO: this function is duplicated from the service-framework and used in other places.
 * Move this somewhere else
 */
function getNameFromClassInstance(instance) {
    try {
        return instance.constructor.name;
    }
    catch (err) { }
    return undefined;
}
exports.getNameFromClassInstance = getNameFromClassInstance;
function errorNameMatches(errorThrown, expectedError) {
    return (Object.getPrototypeOf(errorThrown).constructor.name === expectedError.name);
}
exports.errorNameMatches = errorNameMatches;
